import { Moment } from 'moment';
// Types
import { StreamIntervalEnum } from 'api/graphql-global-types';
import { BoutFormValues } from 'pages/Events/matchcard';

export type TicketEventFormMode = 'create' | 'edit';

export enum VenueMode {
  Saved = 'saved',
  New = 'new',
}

export enum PublishMode {
  Draft = 'draft',
  Publish = 'publish',
}

export type VenueFormValues = {
  name?: string;
  addressLine1?: string;
  addressLine2?: string;
  city?: string;
  region?: string;
  postalCode?: string;
  country?: string;
  latitude?: number;
  longitude?: number;
  timezone?: string;
};

export type TierFormValues = {
  label?: string;
  price?: number;
  capacity?: number;
  maxPerOrder?: number;
  description?: string;
};

export type TicketEventFormValues = {
  hostId?: string;
  streamId?: string | null;
  name?: string;
  description?: string;
  hashtags?: string[];
  venueMode: VenueMode;
  venueId?: string;
  venue?: VenueFormValues;
  startsAt?: Moment | null;
  endsAt?: Moment | null;
  doorsOpenAt?: Moment | null;
  admissionClosesAt?: Moment | null;
  salesOpenAt?: Moment | null;
  salesCloseAt?: Moment | null;
  repeatsEvery?: StreamIntervalEnum | null;
  ticketsEnabled: boolean;
  tiers?: TierFormValues[];
  maxAdmissions?: number | null;
  minimumAge?: number | null;
  promotion?: string;
  entryRequirements?: string;
  refundPolicy?: string;
  termsAndConditions?: string;
  sportIds?: number[];
  leagueId?: string | null;
  affiliateEnabled: boolean;
  affiliateCommissionPercent?: number | null;
  fanPollingEnabled: boolean;
  publishMode: PublishMode;
  approveZeroTax: boolean;
  bouts?: BoutFormValues[];
};
